import {create} from 'zustand'

interface BenefitDetailDialogStore {
  isOpen: boolean
  claimNumber: string
  openDialog: (claimNumber: string) => void
  closeDialog: () => void
}

const useBenefitDetailDialogStore = create<BenefitDetailDialogStore>((set) => ({
  isOpen: false,
  claimNumber: '',
  openDialog: (claimNumber) => set({isOpen: true, claimNumber}),
  closeDialog: () => set({isOpen: false, claimNumber: ''}),
}))

export default useBenefitDetailDialogStore
